const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/liho/eCheckin/sections/DirektAbrechnung.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import { useIntl } from 'react-intl';
import textMap from '../translations';
import { ECheckinSectionProps } from 'App/components/eCheckin/types';
import ECheckinSection from 'App/components/eCheckin/components/ECheckinSection';
import { YesNoField } from 'App/components/eCheckin/components/fields/YesNoField';
import { createFieldPath } from 'App/components/eCheckin/utils';
import { useText } from '@cistec/common_web/utils/intlUtils';

export const DirektAbrechnung = forwardRef((props: ECheckinSectionProps, ref: any) => {
    const { path } = props;
    const title = useText(props.title);

    const PATH_DIREKTABRECHNUNG = createFieldPath(path, 'direktAbrechnung');

    const { formatMessage } = useIntl();
    const eCheckinSectionRef = useCIS4m(ref);

    return (
        <ECheckinSection ref={eCheckinSectionRef} path={path} title={title}>
            <h1>{title}</h1>
            <p>{formatMessage(textMap.infoTextDirektabrechnung)}</p>
            <YesNoField path={PATH_DIREKTABRECHNUNG} required={true} label={textMap.direktabrechnung1} />
        </ECheckinSection>
    );
});

DirektAbrechnung.displayName = 'DirektAbrechnung';

export default DirektAbrechnung;
